type ParseOpts = {
	integer?: boolean;
	min?: number;
	max?: number;
	decimals?: number;
};

export const parseNumberInput = (
	raw: string,
	opts?: ParseOpts,
): number | null => {
	if (raw === "") return null;
	const n = opts?.integer ? parseInt(raw, 10) : parseFloat(raw);
	if (!Number.isFinite(n)) return null;
	if (opts?.min != null && n < opts.min) return null;
	if (opts?.max != null && n > opts.max) return null;
	if (opts?.decimals != null && !opts.integer) {
		const factor = 10 ** opts.decimals;
		return Math.round(n * factor) / factor;
	}
	return n;
};
